import R from 'ramda';
import dispatch from './dispatch';

const YOUTUBE_DOMAINS = ['youtube.com', 'youtu.be'];
const YOUTUBE_TYPE = 'youtube';
const WATCH_FORMAT = 'watch';

const isYoutubeVideo = ({ url }) => YOUTUBE_DOMAINS.some(elem => url.includes(elem));

const isWatchFormat = ({ url }) => url.includes(WATCH_FORMAT);

export const getYoutubeUrl = ({ url }) => (isWatchFormat({ url }) ?
  R.compose(
    R.nth(0),
    R.split('&'),
  )(url) :
  R.compose(
    R.nth(0),
    R.split('?'),
  )(url));

export const getVideoInfo = ({ url, title }) => {
  let filename;
  let type;

  if (isYoutubeVideo({ url })) {
    filename = title;
    type = YOUTUBE_TYPE;
  } else {
    filename = R.compose(
      R.last,
      R.split('/'),
    )(url);

    type = R.compose(
      R.last,
      R.split('.'),
    )(url);
  }

  return {
    filename,
    type,
  };
};

export const trackVideoPlayEvent = ({
  url,
  duration,
  progress,
  title,
}) => {
  const eventName = 'MediaPlay';

  const {
    filename,
    type,
  } = getVideoInfo({
    url,
    title,
  });

  const detail = {
    eventInfo: {
      eventAction: 'Video Media Play',
      eventName,
      eventType: 'userEvent',
      video: {
        videoURL: isYoutubeVideo({ url }) ? getYoutubeUrl({ url }) : url,
        videoName: filename,
        videoType: type,
        videoLength: duration ? `${duration}s` : '',
        videotimePlayed: `${R.prop('playedSeconds')(progress)}s`,
        videoMilestone: '0',
      },
    },
  };

  dispatch({
    eventName,
    detail,
  });
};

export const getEventName = ({ videoMilestone }) => {
  if (videoMilestone === 100) {
    return 'MediaComplete';
  }
  return `Media${videoMilestone}`;
};

export const trackVideoMilestoneEvent = ({
  url,
  duration,
  progress,
  videoMilestone,
  title,
}) => {
  const {
    filename,
    type,
  } = getVideoInfo({
    url,
    title,
  });

  if (videoMilestone === undefined) return;

  const eventName = getEventName({ videoMilestone });
  const detail = {
    eventInfo: {
      eventAction: 'Video Media Viewed',
      eventName,
      eventType: 'userEvent',
      video: {
        videoURL: isYoutubeVideo({ url }) ? getYoutubeUrl({ url }) : url,
        videoName: filename,
        videoType: type,
        videoLength: duration ? `${duration}s` : '',
        videotimePlayed: `${Math.floor(R.prop('playedSeconds', progress))}s`,
        videoMilestone,
      },
    },
  };

  dispatch({
    eventName,
    detail,
  });
};
